import { getTokenFromLocalStorage, useLogoutOnStorageChange } from '@/auth';
import { isMobile } from '@/helpers';
import useIntl from '@/hooks/useIntl';
import ChangePassword from '@/pages/Auth0/Users/Actions/ChangePassword';
import Authentication from '@/services/Authentication';
import { LogoutOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useModel } from '@umijs/max';
import { Avatar, Spin } from 'antd';
import React, { useEffect } from 'react';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';

const AvatarDropdown: React.FC = () => {
    const { changePassword, modal: Modal } = ChangePassword();

    const { isLoading, user, logout, isAuthenticated } = useAuth0();

    const { initialState, setInitialState } = useModel('@@initialState');

    const logoutAllTabs = useLogoutOnStorageChange(logout);

    const t = useIntl();

    const token = getTokenFromLocalStorage();

    useEffect(() => {
        if (!isAuthenticated || !token) return;
        getInfo();
    }, [isAuthenticated, token]);

    const getInfo = async () => {
        const agencyModel = Authentication.getAgencyModel();

        if (agencyModel === null) return;

        setInitialState({
            ...initialState,
            name: agencyModel.userFullName,
        });
    };

    const loading = (
        <span className={`${styles.action} ${styles.account}`}>
            <Spin
                size="small"
                style={{
                    marginLeft: 8,
                    marginRight: 8,
                }}
            />
        </span>
    );

    if (isLoading) {
        return loading;
    }

    const items = [
        {
            key: 'changePassword',
            icon: <SafetyOutlined style={{ color: '#005CA9', fontSize: 15 }} />,
            label: <span style={{ color: '#005CA9' }}>{t('common.changePassword')}</span>,
            onClick: changePassword.event,
        },
        {
            type: 'divider' as const,
        },
        {
            key: 'logout',
            icon: <LogoutOutlined style={{ color: 'red' }} />,
            label: <span style={{ color: 'red' }}>{t('common.LogOut')}</span>,
            onClick: logoutAllTabs,
        },
    ];

    return (
        <>
            <HeaderDropdown menu={{ items }}>
                <span className={`${styles.action} ${styles.account}`}>
                    {!!initialState?.name ? (
                        <img src={user?.picture} alt="profile-pic" style={{ borderRadius: '50%', width: 25, height: 25, marginRight: 6 }} />
                    ) : (
                        <Avatar size="small" className={styles.avatar} src={<UserOutlined />} alt="avatar" />
                    )}
                    {!isMobile() && <span className={`${styles.name} anticon`}>{initialState?.name}</span>}
                </span>
            </HeaderDropdown>
            <Modal onOk={logoutAllTabs} />
        </>
    );
};

export default AvatarDropdown;
